var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29036 3.33337C7.29036 2.9882 7.01054 2.70837 6.66536 2.70837H3.33203C2.98685 2.70837 2.70703 2.9882 2.70703 3.33337V6.66671C2.70703 7.01189 2.98685 7.29171 3.33203 7.29171C3.67721 7.29171 3.95703 7.01189 3.95703 6.66671V4.84226L7.05676 7.94198C7.30083 8.18606 7.69656 8.18606 7.94064 7.94198C8.18472 7.6979 8.18472 7.30218 7.94064 7.0581L4.84091 3.95837H6.66536C7.01054 3.95837 7.29036 3.67855 7.29036 3.33337Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 3.33337C12.707 2.9882 12.9869 2.70837 13.332 2.70837H16.6654C17.0105 2.70837 17.2904 2.9882 17.2904 3.33337V6.66671C17.2904 7.01189 17.0105 7.29171 16.6654 7.29171C16.3202 7.29171 16.0404 7.01189 16.0404 6.66671V4.84226L12.9406 7.94198C12.6966 8.18606 12.3008 8.18606 12.0568 7.94198C11.8127 7.6979 11.8127 7.30218 12.0568 7.0581L15.1565 3.95837H13.332C12.9869 3.95837 12.707 3.67855 12.707 3.33337Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29036 16.6667C7.29036 17.0119 7.01054 17.2917 6.66536 17.2917H3.33203C2.98685 17.2917 2.70703 17.0119 2.70703 16.6667V13.3334C2.70703 12.9882 2.98685 12.7084 3.33203 12.7084C3.67721 12.7084 3.95703 12.9882 3.95703 13.3334V15.1578L7.05676 12.0581C7.30083 11.814 7.69656 11.814 7.94064 12.0581C8.18472 12.3022 8.18472 12.6979 7.94064 12.942L4.84091 16.0417H6.66536C7.01054 16.0417 7.29036 16.3215 7.29036 16.6667Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 16.6667C12.707 17.0119 12.9869 17.2917 13.332 17.2917H16.6654C17.0105 17.2917 17.2904 17.0119 17.2904 16.6667V13.3334C17.2904 12.9882 17.0105 12.7084 16.6654 12.7084C16.3202 12.7084 16.0404 12.9882 16.0404 13.3334V15.1578L12.9406 12.0581C12.6966 11.814 12.3008 11.814 12.0568 12.0581C11.8127 12.3022 11.8127 12.6979 12.0568 12.942L15.1565 16.0417H13.332C12.9869 16.0417 12.707 16.3215 12.707 16.6667Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.89acd534ab10a32df0faf853f82d1475.svg";
export { ForwardRef as ReactComponent };